// @generated by protobuf-ts 2.9.4
// @generated from protobuf file "mlmbox/client/asset/coin_market_cap.proto" (package "mlmbox.client.asset", syntax proto3)
// tslint:disable
import { Asset_MarketCap_List } from "../../types/asset.ts";
import { Empty } from "../../../google/protobuf/empty.ts";
import { Asset_MarketCap } from "../../types/asset.ts";
import { Asset_Id } from "../../types/asset.ts";
import { ServiceType } from "@protobuf-ts/runtime-rpc";
/**
 * @generated ServiceType for protobuf service mlmbox.client.asset.CoinMarketCap
 */
export const CoinMarketCap = new ServiceType("mlmbox.client.asset.CoinMarketCap", [
    { name: "Get", options: {}, I: Asset_Id, O: Asset_MarketCap },
    { name: "All", options: {}, I: Empty, O: Asset_MarketCap_List }
]);
